<template>
    <div class="pagination">
        <div class="pagination__list">
            <button class="pagination__button lighter" :class="classStart" @click.prevent="clickButton('start')">
                <div class="pagination__button_text">
                    <font-awesome-icon icon="fa-solid fa-angles-left"/>
                </div>
            </button>

            <button class="pagination__button" :class="classStart" @click.prevent="clickButton('back')">
                <div class="pagination__button_text">
                    <font-awesome-icon icon="fa-solid fa-angle-left"/>
                </div>
            </button>

            <pagination_button
                v-if="isPage"
                v-for="numberPage of pageRange"
                :key="'button_pagination_'+ numberPage"
                :buttonValue="numberPage"
                :activeValue="currentPage"
                @click_number_page="clickButtonPage"
            />

            <button class="pagination__button" :class="classEnd" @click.prevent="clickButton('forward')">
                <div class="pagination__button_text">
                    <font-awesome-icon icon="fa-solid fa-angle-right"/>
                </div>
            </button>

            <button class="pagination__button lighter" :class="classEnd" @click.prevent="clickButton('end')">
                <div class="pagination__button_text">
                    <font-awesome-icon icon="fa-solid fa-angles-right"/>
                </div>
            </button>
        </div>
    </div>
</template>

<script>

import pagination_button from "./PaginationButton.vue";

import {createHelpers} from "vuex-map-fields";

const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})

export default {
    name: "pagination",
    props: {
    },
    components: {
        pagination_button
    },
    data() {
        return {
            startPage: 0,
            endPage: 0,
        }
    },
    emits: ['click_button_page'],
    beforeMount() {
        this.setStartEndPage(this.filterStopList.activePage);
    },
    methods: {
        clickButtonPage(numberPage) {
            this.setStartEndPage(numberPage);
            this.sendEventPagination(numberPage);
        },
        setStartEndPage(activePage) {
            switch (true) {
                case activePage === 1 :
                    if (this.totalPagesStopListProducts > 2) {
                        this.startPage = 1;
                        this.endPage = 3;
                    } else if (this.totalPagesStopListProducts <= 2) {
                        this.startPage = 1;
                        this.endPage = this.totalPagesStopListProducts;
                    }
                    break;
                case activePage <= 2 && this.totalPagesStopListProducts <= 2 && activePage <= this.totalPagesStopListProducts :
                    if (activePage === 1) {
                        this.startPage = activePage;
                    } else {
                        this.startPage = activePage - 1;
                    }
                    this.endPage = this.totalPagesStopListProducts;
                    break;
                case activePage <= 2 && this.totalPagesStopListProducts > 2 :
                    if (activePage === 1) {
                        this.startPage = activePage;
                        this.endPage = activePage + 2;
                    } else {
                        this.startPage = activePage - 1;
                        this.endPage = activePage + 1;
                    }
                    break;
                case activePage > 2 && this.totalPagesStopListProducts >= 2 && activePage < this.totalPagesStopListProducts :
                    this.startPage = activePage - 1;
                    this.endPage = activePage + 1;
                    break;
                case activePage > 2 && this.totalPagesStopListProducts === activePage :
                    this.startPage = activePage - 2;
                    this.endPage = activePage;
                    break;
            }
        },
        clickButton(action) {
            let activePage = this.currentPage;

            if (((action === 'start' || action === 'back') && this.currentPage <= 1) || ((action === 'forward' || action === 'end') && activePage >= this.totalPagesStopListProducts)) {
                return;
            }

            if (action === 'start') {
                activePage = 1;

            }
            if (action === 'back') {
                if (this.currentPage - 1 >= 1) {
                    activePage -= 1;
                } else {
                    activePage = 1;
                }
            }
            if (action === 'forward') {
                if (this.currentPage + 1 <= this.totalPagesStopListProducts) {
                    activePage += 1;
                } else {
                    activePage = this.totalPagesStopListProducts;
                }
            }
            if (action === 'end') {
                activePage = this.totalPagesStopListProducts;
            }
            this.setStartEndPage(activePage);
            this.sendEventPagination(activePage);
        },
        sendEventPagination(numberPage) {
            EventBus.$emit('click_button_page', numberPage);
        }
    },
    computed: {
        ...mStopList([
            'filterStopList',
            'totalPagesStopListProducts',
        ]),
        classStart() {
            if (this.currentPage === 1 || this.currentPage === 0) {
                return 'inactive';
            }
            return '';
        },
        classEnd() {
            if (this.currentPage === this.totalPagesStopListProducts) {
                return 'inactive';
            }
            return '';
        },
        pageRange() {
            if (this.totalPagesStopListProducts === 0) {
                return [];
            }
            return Array.from(
                {length: this.endPage - this.startPage + 1},
                (_, index) => this.startPage + index
            );
        },
        isPage() {
            if (this.pageRange.length > 0) {
                return true;
            }
            return false;
        },
        currentPage() {
            if (this.filterStopList.activePage && this.filterStopList.activePage > 0) {
                return this.filterStopList.activePage;
            }
            return 1;
        }
    },
}
</script>
